import React, { useState, useEffect, useCallback } from 'react';
import RecipeCard from '../components/RecipeCard';
import client from '../api/client';
import './Home.css';

function Home() {
  const [recipes, setRecipes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [difficulty, setDifficulty] = useState('');
  const [maxPrepTime, setMaxPrepTime] = useState('');
  const [sortBy, setSortBy] = useState('created_at');
  const [author, setAuthor] = useState('');

  const fetchRecipes = useCallback(async () => {
    setLoading(true);
    try {
      const params = {};
      if (search) params.search = search;
      if (difficulty) params.difficulty = difficulty;
      if (maxPrepTime) params.max_prep_time = maxPrepTime;
      if (sortBy) params.sort_by = sortBy;
      if (author) params.author = author;
      const res = await client.get('/api/recipes', { params });
      setRecipes(res.data.recipes || []);
    } catch (err) {
      console.error('Error al cargar las recetas', err);
    } finally {
      setLoading(false);
    }
  }, [search, difficulty, maxPrepTime, sortBy, author]);

  useEffect(() => {
    const timer = setTimeout(fetchRecipes, 300);
    return () => clearTimeout(timer);
  }, [fetchRecipes]);

  const hasFilters = search || difficulty || maxPrepTime || author;

  return (
    <div className="home">
      <h1 className="home-title">Descubre Recetas 🥘</h1>
      <div className="home-filters card">
        <input
          className="form-control"
          type="text"
          placeholder="Buscar recetas..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
        <div className="home-filter-row">
          <select
            className="form-control"
            value={difficulty}
            onChange={e => setDifficulty(e.target.value)}
          >
            <option value="">Todas las dificultades</option>
            <option value="easy">Fácil</option>
            <option value="medium">Media</option>
            <option value="hard">Difícil</option>
          </select>
          <select
            className="form-control"
            value={sortBy}
            onChange={e => setSortBy(e.target.value)}
          >
            <option value="created_at">Más recientes</option>
            <option value="prep_time">Tiempo de preparación</option>
            <option value="title">Título A–Z</option>
          </select>
        </div>
        <div className="home-filter-row">
          <input
            className="form-control"
            type="number"
            min="1"
            placeholder="Tiempo máx. de preparación (min)"
            value={maxPrepTime}
            onChange={e => setMaxPrepTime(e.target.value)}
          />
          <input
            className="form-control"
            type="text"
            placeholder="Filtrar por usuario..."
            value={author}
            onChange={e => setAuthor(e.target.value)}
          />
        </div>
        {hasFilters && (
          <button
            className="btn btn-outline"
            onClick={() => { setSearch(''); setDifficulty(''); setMaxPrepTime(''); setAuthor(''); }}
          >
            Limpiar filtros
          </button>
        )}
      </div>

      {loading ? (
        <div className="loading">Cargando recetas...</div>
      ) : recipes.length === 0 ? (
        <div className="home-empty">
          <span>🍴</span>
          <p>No se encontraron recetas. ¡Sé el primero en añadir una!</p>
        </div>
      ) : (
        <div className="home-grid">
          {recipes.map(r => <RecipeCard key={r.id} recipe={r} />)}
        </div>
      )}
    </div>
  );
}

export default Home;
